module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"privacyPolicy":"Политика конфиденциальности"}}')
  delete Component.options._Ctor
}
